import {IDefaultService} from '../iDefault.service';
import {AbstractRepositoryV2} from '../../abstractRepositoryV2';
import {Sort, UrlParameter} from '../../../../../../shared/utils/url.builder';
import {Observable, Subscription} from 'rxjs';
import {Page} from '../../../../../../shared/model/core/page.model';
import {PaginatedServiceUtils} from '../paginated/paginatedService.utils';
import {Pageable} from '../../../../../../shared/model/core/pageable.model';
import {AbstractDataServiceAdapter} from '../../dataservice/adapter/abstractDataService.adapter';

export abstract class AbstractFindManyService<StoredEntity, Entity>
    extends IDefaultService<StoredEntity, Entity> {

    refreshOnUpdated = true;
    refreshOnCreated = true;
    refreshOnDeleted = true;

    protected static readonly MAX_PAGE_SIZE = 200;

    parameters: UrlParameter[] = [];
    additionalParameters: UrlParameter[] = [];
    sort: Sort;

    private subscriptions: Subscription[] = [];

    protected constructor(service: AbstractRepositoryV2<StoredEntity>,
                          dataService: AbstractDataServiceAdapter<StoredEntity, Entity, any>,
                          parameters?: UrlParameter[]) {
        super(service, dataService);
        this.parameters = parameters;

        this.subscriptions.push(this.repository.created$.subscribe(value => {
            if (value && this.refreshOnCreated) {
                this.refresh();
            }
        }));
        this.subscriptions.push(this.repository.multipleCreated$.subscribe(value => {
            if (value && this.refreshOnCreated) {
                this.refresh();
            }
        }));

        this.subscriptions.push(this.repository.updated$.subscribe(value => {
            if (value && this.refreshOnUpdated) {
                this.refresh();
            }
        }));
        this.subscriptions.push(this.repository.deleted$.subscribe(value => {
            if (value && this.refreshOnDeleted) {
                this.refresh();
            }
        }));
    }

    onDestroy() {
        // console.log('destroy service');
        this.subscriptions.forEach(value => value.unsubscribe());
    }

    abstract refresh();

    protected coreFindPaginatedByDataService(pageable: Pageable,
                                             additionalParameters?: UrlParameter[]): Observable<Page<Entity>> {
        this.additionalParameters = additionalParameters;
        return PaginatedServiceUtils.findPaginated(this.dataService,
            this.buildFullPath(),
            pageable,
            this.parameters,
            this.additionalParameters);
    }


    private buildFullPath(): string {
        return this.dataService.isDtoSummary() ? 'summary' : '';
    }

    get allParameters(): UrlParameter[] {
        const allParameters: UrlParameter[] = [];
        if (this.parameters?.length > 0) {
            this.parameters.forEach((parameter: UrlParameter) => allParameters.push(parameter));
        }
        if (this.additionalParameters?.length > 0) {
            this.additionalParameters.forEach((parameter: UrlParameter) => allParameters.push(parameter));
        }
        return allParameters;
    }

}
